<template>
  <div class="active-banners">
    <active-banners v-if="currentLocation" v-for="banner in showActiveBanners" :banner="banner" :key="banner.id" />
  </div>
</template>

<script async>
import { mapGetters } from 'vuex'
import ActiveBanners from './ActiveBanners'

export default {
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation'
    }),
    showActiveBanners () {
      if (this.currentLocation && this.currentLocation.hasOwnProperty('notification_banners')) {
        return this.currentLocation.notification_banners
      }
      return []
    }
  },
  components: {
    ActiveBanners
  }
}
</script>

<style lang="scss" scoped>
  .active-banners {
    position: relative;
    z-index: 1;
  }
</style>
